import * as React from "react";
const SvgIconActionStop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 4, y: 4, width: 8, height: 8, rx: 2, fill: "#7C8FAC" }));
export { SvgIconActionStop as ReactComponent };
